const actions = {
	SET_GROUP_OWNER: "SET_GROUP_OWNER"
};

export default actions;
